import React, { useEffect, useState } from "react";

import { useMutation } from "react-query";
import { toast } from "react-toastify";
import { Spinner } from "reactstrap";
import { updateCurios } from "../../../../MyApi/curior";
import EditPen from "../../../Common/svg/editpenicon";
import MessageIcon from "../../../Common/svg/messageicon";
import StatusBadge from "../../../UI/statusBadge";
import StarIcon from "../../../Common/svg/staricon";
import { useNavigate } from "react-router-dom";

const CuriorStatusCard = ({
  categories,
  name,
  logo,
  is_closed,
  id,
  refetch,
  avatar,
  driverId,
  avg_rate,
  statusApi,
}) => {
  const navigate = useNavigate();
  const [status, setStatus] = useState(statusApi);
  useEffect(() => {
    setStatus(statusApi);
  }, []);

  const mutation = useMutation({
    mutationKey: ["updateCuriorStatus"],
    mutationFn: (postData) => updateCurios(postData, id),
    onSuccess: (data) => {
      toast.success(`${data.message}`);
      refetch();
    },
    onError: (error) => {
      toast.error(`${error.response.data.message}`);
    },
  });
  const handleChangeStatus = (e) => {
    const { value } = e.target;
    const formData = new FormData();
    setStatus(value);
    formData.append("courier[status]", value);
    formData.append("_method", "PUT");
    mutation.mutate(formData);
  };
  return (
    <div className="card rounded-4 shadow-sm">
      <div className="card-body">
        <div className="d-flex justify-content-between">
          <div className="d-flex align-items-center gap-3">
            <div className="avatar">
              <img
                className="media rounded-circle img-80 "
                src={avatar}
                alt={name}
              />
            </div>
            <div>
              <div className="d-flex  align-items-center  gap-3">
                <h5>{name}</h5>
                <StatusBadge status={statusApi} />
              </div>
              <h4 className="desc font16 mt-3">المعرف : {driverId}</h4>
              <div className="text-center">
                <span>
                  <StarIcon /> {avg_rate}
                </span>
                <span className="desc">متوسط التقييم </span>
              </div>
            </div>
          </div>
          <div>
            <div className="d-flex align-items-center gap-2 mb-2">
              <button
                className="btn btn-white"
                onClick={() =>
                  navigate(`${process.env.PUBLIC_URL}/curior/edit/${id}`)
                }
              >
                <EditPen />
              </button>
              {/* <button className="btn btn-white">
                  <MessageIcon />
                </button> */}
              {mutation.isLoading ? (
                <Spinner />
              ) : (
                <select
                  className="form-select"
                  onChange={handleChangeStatus}
                  value={status}
                >
                  <option value={""}>حالة الحساب</option>
                  <option value={"active"}>نشط</option>
                  <option value={"inactive"}>غير نشط</option>
                  <option value="blocked">محظور</option>
                </select>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CuriorStatusCard;
